import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MilitaryObligationsDto  {
    _originalTypeClassName = "zSHR.BO.MilitaryObligationsDto";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MilitaryObligationsDto.translate = translateService;
}
this.Value = null;
this.MilitaryObligationsDtoKey = null;
this._key = this.MilitaryObligationsDtoKey = 0; 
}

static translate: TranslateService;
_key: any;
Value:any;
private _MilitaryObligationsDtoKey:any;
get MilitaryObligationsDtoKey(): any {
    return this._MilitaryObligationsDtoKey;
  }
set MilitaryObligationsDtoKey(value: any) {
    this._MilitaryObligationsDtoKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MilitaryObligationsDtoKey == null || $this.MilitaryObligationsDtoKey == 0;
            }


}